<template>
  <div class="incomeHomeServiceLabor">
    <!-- 添加表格 -->
      <el-card>
        <el-table
          :data="tableData"
          class="wid100"
          :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
          :row-class-name="tableRowClassName"
          @selection-change="handleSelectionChange"
        >
        <!-- checkbox -->
          <el-table-column type="selection" width="55" v-if="this.homeServiceCommissioncheckbox"></el-table-column>
          <!-- 序号 -->
          <el-table-column
            type="index"
            :index="indexMethod" align="center"
            :label="$t('lang.lab_index')"
            width="100px"
          ></el-table-column>
          <!-- 人员类别 -->
          <el-table-column prop="staffType" :label="$t('lang.lab_catePerson')">
            <template slot-scope="scope">
              <span
                v-if="scope.row.staffType === '1'"
              >{{$t('lang.INCOMEHONESERVICELABOR.STAFFTYPE[0].label')}}</span>
              <span
                v-if="scope.row.staffType === '2'"
              >{{$t('lang.INCOMEHONESERVICELABOR.STAFFTYPE[1].label')}}</span>
              <span
                v-if="scope.row.staffType === '3'"
              >{{$t('lang.INCOMEHONESERVICELABOR.STAFFTYPE[2].label')}}</span>
            </template>
          </el-table-column>
          <!-- 最小信用积分 -->
          <el-table-column prop="minCreditScore" sortable :label="$t('lang.lab_minCreditScore')"></el-table-column>
          <!-- 提成比例 -->
          <el-table-column prop="proportions" sortable :label="$t('lang.lab_Royalty_unit')"></el-table-column>
          <el-table-column :label="$t('lang.lab_operation')" fixed="right" :width="require('@/config/enum').opr_width1">
            <template slot-scope="scope">
              <el-button @click="details(scope.row.id)">{{$t('lang.btn_modify')}}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
      <!-- 加弹框 -->
        <el-dialog
          :title="$t('lang.lab_modifyRules')"
          :visible.sync="diaIsShow"
          :close-on-click-modal="false"
          center
          top="130px"
          width="600px"
          @closed="handleDialogClosed"
        >
        <!-- 表单验证 -->
          <el-form :model="form" :rules="rules" ref="form" :label-width="require('@/config/enum').c_ws7" :label-suffix="require('@/config/enum').c_colon">
            <!-- 最小积分 -->
            <el-form-item :label="$t('lang.lab_minCreditScore')" prop="minCreditScore">
              <el-input v-model="form.minCreditScore" maxlength="4" onkeyup="this.value=this.value.replace(/[^\d.]/g,'');"></el-input>
            </el-form-item>
            <!-- 提成比例 -->
            <el-form-item :label="$t('lang.lab_Royalty_unit')" prop="proportions">
              <el-input v-model="form.proportions" maxlength="4" onkeyup="this.value=this.value.replace(/[^\d.]/g,'');"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="clear()">{{$t('lang.btn_rest')}}</el-button>
            <el-button type="primary" :disabled="isDisabled" @click="save('form')">{{$t('lang.btn_save')}}</el-button>
          </div>
        </el-dialog>
  </div>
</template>

<script>
/**
 *@ClassName:communityManagement
 *@Description:居家服务劳动提成设置
 *@author:李斌
 *@Copyright:格众科技
 *@date:2020-03-04
 */
export default {
  // 默认显示数据
  data() {
    return {
      tableData: [], // 表单数据
      isDisabled: true, // 按钮置灰
      saveData: '', // 存储json字符串
      homeServiceCommissioncheckbox: require('@/config/enum').homeServiceCommissioncheckbox, // 是否隐藏复选框
      diaIsShow: false, // 弹框是否显示
      editId: '',
      multipleSelection: [], // 多选框
      pageCount: 0, // 总页数
      pageNo: 1, // 页数
      pageSize: 10, // 每页显示数量
      form: {
        minCreditScore: '',
        proportions: ''
      },
      rules: {
        minCreditScore: [
          { required: true, message: this.$i18n.t('lang.lab_pleaseInputMinCreditScore'), trigger: 'blur' },
        ],
        proportions: [  
          {
            required: true,
            message: this.$i18n.t('lang.lab_pleaseInputRoyalty'),
            trigger: 'blur'
          }
        ]
      }
    }
  },
  // 初始化
  created() {
    this.topics()
  },
  watch: {
    form: {
      handler(newVal, oldVal) {
        let tempRule = JSON.stringify(newVal)
        if (tempRule === this.saveData) {
          this.isDisabled = true
        } else {
          this.isDisabled = false
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // ID序号功能
    indexMethod(index) {
      return (this.pageNo - 1) * this.pageSize + index + 1
    },
    // 列表斑马线
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // 添加多选框
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 显示页面
    topics() {
      let loading = this.$loading()
      this.$get(`/getServiceCommissionExtract`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.tableData = res.list
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    details(id) {
      this.editId = id
      let loading = this.$loading()
      this.$get(`/getServiceCommissionExtractById/` + id).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.form.minCreditScore = res.list.minCreditScore.toString()
            this.form.proportions = res.list.proportions.toString()
            this.saveData = JSON.stringify(this.form)
            this.diaIsShow = true
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },

    // 弹窗保存
    save(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let loading = this.$loading()
          let params = {
            minCreditScore: this.form.minCreditScore,
            proportions: this.form.proportions
          }
          this.$patch(
            `/editServiceCommissionExtract/${this.editId}`,
            params
          ).then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                this.$message.success(this.$i18n.t('lang.lab_save_success'))
                this.diaIsShow = false
                this.topics()
              }
            },
            error => {
              loading.close()
              this.diaIsShow = false
              this.$message.error(error)
            }
          )
        }
      })
    },
    // 弹窗清空
    clear() {
      this.form.minCreditScore = ''
      this.form.proportions = ''
      this.$refs.form.clearValidate()
    },
    // 监听关闭dialog
    handleDialogClosed() {
      this.clear()
    }
  }
}
</script>

<style lang= 'scss'>

</style>
